import type { CotizacionVigente } from "@/components/money";

/**
 * Cotizacion con la que arranca la app hasta que responde el backend.
 *
 * Se marca MANUAL a proposito: mientras no haya una fuente automatica confirmada,
 * la UI tiene que gritar que ese numero lo puso una persona. Un AUTO mentiroso es
 * peor que un MANUAL honesto.
 */
export const COTIZACION_ARRANQUE: CotizacionVigente = {
  valor: 1,
  origen: "MANUAL",
  actualizada: new Date(0).toISOString(),
  fuente: "Sin cotizacion cargada",
};
